import React, {useEffect} from "react"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { AppOfficesBlock } from "@components"
import { BACKEND_APIS } from "@constants"
import {useSignal} from "@preact/signals-react";


export default function AppAsyncOfficesAutocomplete({ ...props }) {

    return <AutocompleteAsyncSeeker
		label="Offices"
		placeholder="All offices"
		formatOptionLabel={({ label, office_type, country }) => <AppOfficesBlock name={label} type={office_type} country={country} /> }
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/office`}
		{...props}
	/>
}